// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"f7ee902a","417":"c96fdc6b","885":"9be45269","951":"88fd56ce"}[chunkId] + ".chunk.css";
};